'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stageInitialMessage = stageInitialMessage;

var _getPreviousMessageClientTs = require('../../selectors/pubNubMessageSelectors/getPreviousMessageClientTs');

var _getIsBot = require('../../selectors/widgetDataSelectors/getIsBot');

var _getFirstMessageText = require('../../thread-histories/selectors/getFirstMessageText');

var _getInitialResponder = require('../../responders/selectors/getInitialResponder');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _getCurrentThreadId = require('../../selectors/conversationSelectors/getCurrentThreadId');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _buildScheduledMessage = require('conversations-schema/factories/PubNubMessageFactory/buildScheduledMessage');

var _initialMessageStaged = require('../ConversationsActions/initialMessageStaged');

var _addMessageToStubbedThread = require('../../stubbed-thread-history/actions/addMessageToStubbedThread');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _MessageDescriptorSources = require('conversations-schema/constants/MessageDescriptorSources');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function stageInitialMessage() {
  return function (dispatch, getState) {
    var _metadata;

    var channel = (0, _getCurrentChannel.getCurrentChannel)(getState());
    var threadId = (0, _getCurrentThreadId.getCurrentThreadId)(getState());

    var isBot = (0, _getIsBot.getIsBot)(getState());
    var responderToUse = (0, _getInitialResponder.getInitialResponder)(getState());
    var senderId = (0, _responderGetters.getUserId)(responderToUse);

    var message = (0, _buildScheduledMessage.buildScheduledMessage)({
      metadata: (_metadata = {}, _defineProperty(_metadata, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.INITIAL_MESSAGE), _defineProperty(_metadata, 'text', (0, _getFirstMessageText.getFirstMessageText)(getState())), _defineProperty(_metadata, 'previousMessageClientTs', (0, _getPreviousMessageClientTs.getPreviousMessageClientTs)(getState())), _metadata),
      descriptor: { channel: channel, source: _MessageDescriptorSources.THIS_CLIENT },
      senderType: isBot ? _senderTypes.BOT : _senderTypes.AGENT,
      senderId: senderId,
      threadId: threadId
    });

    dispatch((0, _addMessageToStubbedThread.addMessageToStubbedThread)(message));

    dispatch((0, _initialMessageStaged.initialMessageStaged)({ channel: channel, isBot: isBot }));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/PublishActions/stageInitialMessage.js
// module id = 241
// module chunks = 2 3